var urldata;
function getUrl() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^#&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
};

var getUrlVars = function(urlData){
    urlData = urlData || '';
    urldata = getUrl()[urlData]==undefined?"":getUrl()[urlData];
    return urldata;
}
module.exports = getUrlVars;



//////////////////
// WEBPACK FOOTER
// ./~/@dp/util-get-url/index.js
// module id = 555
// module chunks = 1 12 14